/**
 * Rola a página ou um elemento específico para o topo com animação suave.
 *
 * @param {string | undefined} element - Um seletor CSS representando o elemento a ser rolado.
 *                                        Se não for fornecido ou inválido, usa o objeto `window` por padrão.
 */
export const scrollToTop = ( element ) => {
    if (!element) {
        console.warn(
            `Elemento não encontrado para o seletor: "${element}". Usando 'document.documentElement' como fallback.`
        );

        document.documentElement.scrollTo({
            behavior: 'smooth', 
            top: 0 
        })

        return;
    }

    element.scrollTo({
        behavior: 'smooth', 
        top: 0 
    })
    
}